import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import {
  AccountUser,
  ChangePasswordRequest,
  ChangePasswordResponse,
  LocationUser,
  UpdateUserInfoRequest,
  UpdateUserInfoResponse,
  User,
} from '@shared/user/models';
import { Account } from '@shared/account/models';
import { Location } from '@shared/location/models';
import { InviteWithAccountName } from '@shared/invite/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({ providedIn: 'root' })
export class UserApiService {
  private readonly basePath = '/v.1/users';

  constructor(
    private readonly http: ApiClientService,
  ) {
  }

  get(): Observable<User> {
    return this.http.get<User>(this.basePath);
  }

  getAccounts(): Observable<Account[]> {
    return this.http.get<Account[]>(`${this.basePath}/accounts`);
  }

  getLocations(): Observable<Location[]> {
    return this.http.get<Location[]>(`${this.basePath}/locations`);
  }

  getAccountUsers(): Observable<AccountUser[]> {
    return this.http.get<AccountUser[]>(`${this.basePath}/account-users`);
  }

  getLocationUsers(): Observable<LocationUser[]> {
    return this.http.get<LocationUser[]>(`${this.basePath}/location-users`);
  }

  getInvites(): Observable<InviteWithAccountName[]> {
    return this.http.get<InviteWithAccountName[]>(`${this.basePath}/invites`);
  }

  update(data: UpdateUserInfoRequest): Observable<UpdateUserInfoResponse> {
    return this.http.put<UpdateUserInfoResponse>(`${this.basePath}`, data)
      .pipe(
        map(result => {
          if ((result as any).success) {
            return result;
          }

          throw new Error((result as any).error);
        })
      );
  }

  updatePassword(data: ChangePasswordRequest): Observable<ChangePasswordResponse> {
    return this.http.post<ChangePasswordResponse>(`${this.basePath}/password`, data)
      .pipe(
        map(result => {
          if (result.success) {
            return result;
          }

          throw new Error(result.error);
        })
      );
  }
}
